import React from "react";
import { inject, observer } from "mobx-react";
import { observable } from "mobx";

import { IManagementStore } from "Stores/Management/types";
import PositionsContent from "./PositionsContent/PositionsContent";
import { Values } from "@src/Tools/Values";

interface IProps {
  management?: IManagementStore;
}

@inject("management")
@observer
class ManagePositions extends React.Component<IProps> {
  @observable isLoading: boolean = true;

  async componentDidMount() {
    try {
      await Promise.all([
        this.props.management.getActivePermissionGroups(),
        this.props.management.getPositions(),
        this.props.management.getOptions(),
      ]);
      this.isLoading = false;
      document.title = Values.getLocalizationValue("positionTypes");
    } catch (error) {
      console.error(error);
    }
  }
  render() {
    return <div>{this.isLoading ? <div /> : <PositionsContent />}</div>;
  }
}

export default ManagePositions;
